import React from 'react';
import PropTypes from 'prop-types';
import { sanitizeString } from '../../../../../../../ui-kitchen/src/utils/sanitizeString';
import './AmexGDAOffersTerms.scss';
import { handleMktAnalytics } from '../../../AmexMarketingUtils/AmexUtils';
import { ACQUISITION_CTA_EVENT_NAME } from '../../../AmexMarketingUtils/constants';

const AmexGDAOffersTerms = (props) => {
  const {
    amexCardData: {
      fees,
      offersAndBenefitsLink,
      rates,
      ratesAndFeesLink,
    },
    resyCardData: {
      productAnnualFeeLabel,
      productRateAndFeesLabel,
      productRateAndFeesSymbol,
      productOfferBenefitTermsLabel,
      productOfferBenefitTermsSymbol,
      rateAndFeesAriaLabel,
      rateAndFeesTrack,
      offerBenefitTermsAriaLabel,
      offerBenefitTermsTrack,
      annualFeeSymbol,
      aprName,
      aprSymbol,
      aprPayOverTimeText,
    },
    Analytics,
  } = props;

  const renderAPR = () => {
    let aprBody = rates.filter((rate) => rate.name === aprName)[0].display_text;
    if (aprSymbol) {
      aprBody = `${aprBody}${aprSymbol}`;
    }
    const aprPayOverTimeValue = aprPayOverTimeText ? (`${aprPayOverTimeText}<br />`) : '';
    const sanitizedAPRString = sanitizeString(`${aprPayOverTimeValue}${aprBody}`);
    return (
      <>
        <p
          className="small small--height"
          dangerouslySetInnerHTML={{ // eslint-disable-line react/no-danger
            __html: sanitizedAPRString,
          }}
        />
      </>
    );
  };

  const renderAnnualFee = () => {
    const annualFeeValue = fees.filter((fee) => fee.name === 'ANNUAL_FEE')[0].value;
    return (<p>{`${productAnnualFeeLabel}${annualFeeValue}${annualFeeSymbol}`}</p>);
  };

  const onClickLink = (link) => {
    let actionName;

    if (link === 'TERMS') {
      actionName = 'NAA - Platinum Terms Link Click';
    } else if (link === 'RATES') {
      actionName = 'NAA - Platinum Rates Link Click';
    }
    const extraParams = {
      action_name: actionName,
    };
    handleMktAnalytics(Analytics.event, ACQUISITION_CTA_EVENT_NAME, extraParams);
  };

  const renderLinks = () => (
    <p className="small">
      <sup>{productOfferBenefitTermsSymbol}</sup>
      <a
        href={offersAndBenefitsLink}
        aria-label={offerBenefitTermsAriaLabel}
        target="_blank"
        className="AmexGDAOffersTerms__link"
        rel="noopener noreferrer"
        resy-track-link={offerBenefitTermsTrack}
        onContextMenu={() => onClickLink('TERMS')}
        onClick={() => onClickLink('TERMS')}
      >
        {productOfferBenefitTermsLabel}
      </a>
      <span> | </span>
      <sup>{productRateAndFeesSymbol}</sup>
      <a
        href={ratesAndFeesLink}
        aria-label={rateAndFeesAriaLabel}
        target="_blank"
        className="AmexGDAOffersTerms__link"
        rel="noopener noreferrer"
        resy-track-link={rateAndFeesTrack}
        onContextMenu={() => onClickLink('RATES')}
        onClick={() => onClickLink('RATES')}
      >
        {productRateAndFeesLabel}
      </a>
    </p>
  );

  return (
    <div className="AmexGDAOffersTerms__card--terms">
      {renderAnnualFee()}
      {renderLinks()}
      {renderAPR()}
    </div>
  );
};
AmexGDAOffersTerms.propTypes = {
  amexCardData: PropTypes.shape(PropTypes.shape().isRequired).isRequired,
  resyCardData: PropTypes.shape(PropTypes.shape().isRequired).isRequired,
  Analytics: PropTypes.shape({
    event: PropTypes.func,
  }).isRequired,
};
export default AmexGDAOffersTerms;
